import type { FC } from 'react';
import React from 'react';
import { NamedContainer } from '@alfa-bank/site-named-container';
import { Img } from '@alfa-bank/site-img';
import cn from 'classnames';

import styles from './styles/styles.css';
import type { TProductCard } from './models';

export const ProductCard: FC<TProductCard> = ({
    Block,
    PromoCard,
    Text,
    backgroundColor,
    borderRadius,
    className,
    height,
    imageHeight,
    imagePosition = 'top',
    imageProps,
    imageSrc,
    imageWidth,
    isMobile,
    isSelected,
    onClick,
    subTitle,
    title,
    value,
    width,
}) => {
    const isWithText = title || subTitle;
    const directionClassName = imagePosition === 'top' ? styles.column : styles.columnReverse;

    const defaultImageProps = {
        height: isMobile ? 96 : 112,
        width: 'auto',
    };

    return (
        <PromoCard
            key={value}
            backgroundColor={backgroundColor}
            borderRadius={borderRadius}
            className={cn(
                styles.cardBordered,
                styles.override,
                styles.external,
                isSelected && styles.selected,
                className
            )}
            height={height || '100%'}
            onClick={e => onClick?.(e, value)}
            padding={0}
            width={width || '100%'}
        >
            <NamedContainer name="content">
                <div className={cn(styles.cardContent, styles.external, directionClassName)}>
                    {imageSrc && (
                        <Img
                            height={imageHeight || defaultImageProps.height}
                            src={imageSrc}
                            styler={isWithText ? undefined : { marginTop: 16, marginBottom: 16 }}
                            width={imageWidth || defaultImageProps.width}
                            {...imageProps}
                        />
                    )}
                    {isWithText && (
                        <Block
                            notPadded
                            styler={{
                                paddingLeft: 16,
                                paddingRight: 16,
                                paddingTop: imageSrc && imagePosition === 'top' ? 12 : 16,
                                paddingBottom: imageSrc && imagePosition === 'bottom' ? 12 : 16,
                            }}
                        >
                            {title && (
                                <Text
                                    styler={{ marginBottom: subTitle ? 8 : 0, marginTop: 0 }}
                                    view={
                                        isMobile ? 'accent-primary-small' : 'accent-primary-medium'
                                    }
                                >
                                    {title}
                                </Text>
                            )}
                            {subTitle && (
                                <Text
                                    styler={{ marginBottom: 0, marginTop: 0 }}
                                    view="component-secondary"
                                >
                                    {subTitle}
                                </Text>
                            )}
                        </Block>
                    )}
                </div>
            </NamedContainer>
        </PromoCard>
    );
};
